import React, { Suspense, useEffect } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import woothee from 'woothee';

// dynamic import
const Survey = React.lazy(() => import(/* webpackChunkName: "Survey" */ 'containers/Survey'));
const Backend = React.lazy(() => import(/* webpackChunkName: "Backend" */ 'containers/Backend'));
const Completed = React.lazy(
  () => import(/* webpackChunkName: "Completed" */ 'components/common/Completed'),
);
const Closed = React.lazy(
  () => import(/* webpackChunkName: "Closed" */ 'components/common/Closed'),
);
const BaseNotFound = React.lazy(
  () => import(/* webpackChunkName: "BaseNotFound" */ 'components/common/NotFound'),
);

type Props = {
  isInitializedXCSRFToken: boolean;
  onRequestFetchXCSRFToken: () => void;
  setDeviceVariant: (userDevice: string) => void;
};

const App = (props: Props) => {
  const { isInitializedXCSRFToken, onRequestFetchXCSRFToken, setDeviceVariant } = props;
  const userAgent = woothee.parse(navigator.userAgent);
  const userDevice = userAgent.category;

  useEffect(() => {
    onRequestFetchXCSRFToken();
    setDeviceVariant(userDevice);
  }, []);

  if (!isInitializedXCSRFToken) return null;

  return (
    <Suspense fallback={null}>
      <Switch>
        <Route path='/surveys/:id' component={Survey} />
        <Route path={['/admin', '/backyard']} component={Backend} />
        <Route exact path='/' render={() => <Redirect to='/admin/sign_in' />} />
        <Route path='/completed' component={Completed} />
        <Route path='/closed' component={Closed} />
        <Route path='/' component={BaseNotFound} />
      </Switch>
    </Suspense>
  );
};

export default App;
